module.exports = __webpack_public_path__ + "img/liaojie.3e8e2d3b.png";